"use client";

import React from "react";
import { MapPin, Mail, CircleCheck, CircleAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contactDetails = [{
  icon: MapPin,
  title: "Locatie",
  content: "Eindhoven, Nederland",
  link: null
}, {
  icon: Mail,
  title: "E-mail",
  content: "ralph@goodvibeshoreca.nl",
  link: "mailto:ralph@goodvibeshoreca.nl"
}];
export default function ContactSection() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="contact-section" className="py-20 md:py-32 bg-background relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-primary/5 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-secondary/50 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-foreground mb-6">Laten we kennismaken</h2>
          <p className="text-muted-foreground !text-base">Heb je een vraag, zoek je ondersteuning voor jouw horecazaak of ben je benieuwd wat Good Vibes Hospitality voor jouw bedrijf kan betekenen?<div><br /></div><div>Wij denken graag met je mee. Van operatie en personeel tot marketing, groei en rendement. Neem vrijblijvend contact met ons op, dan kijken we samen naar de mogelijkheden.</div></p>
        </div>

        <div ref={contentRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 items-start transition-all duration-700 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-5 space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-6">
              {contactDetails.map((detail, i) => <Card key={i} data-index={i} className="border-border/50 shadow-sm hover:shadow-md transition-shadow duration-300 bg-card/50 backdrop-blur-sm">
                  <CardContent className="p-6 flex items-start gap-4">
                    <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                      <detail.icon className="size-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-default font-semibold text-foreground mb-1">
                        {detail.title}
                      </h3>
                      {detail.link ? <Link to={detail.link} className="text-muted-foreground hover:text-primary transition-colors text-sm">
                          {detail.content}
                        </Link> : <p className="text-muted-foreground text-sm leading-relaxed">
                          {detail.content}
                        </p>}
                    </div>
                  </CardContent>
                </Card>)}
            </div>
          </div>

          <div className="lg:col-span-7">
            <Card className="border-border/50 shadow-lg bg-card/80 backdrop-blur-md">
              <CardContent className="p-6 md:p-8">
                <div className="mb-8">
                  <h3 className="text-2xl font-default font-semibold text-foreground mb-2">Stuur ons een bericht</h3>
                  <p className="text-muted-foreground text-sm">Wij denken graag vrijblijvend met je mee.&nbsp;</p>
                </div>
                <Button asChild className="w-full sm:w-auto">
                  <Link to="https://forms.monday.com/forms/fb496b700d17ce22e3514fb71ddd4471?r=euc1" target="_blank" rel="noopener noreferrer">Plan een gesprek</Link>
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}